module.exports = __webpack_public_path__ + "static/media/franchiseManagement-01.d982c8f6.png";